
        <div class="col-12">
            <img src="assets/images/ITPB.png" alt="Image Background Image" class="main-img img-fluid"
              loading="lazy">
        </div>
        <div class="container">
            <div  class="row justify-content-center align-items-center">
                <div class="restPasswordSection">
                    <div  class="col-md-12">
                        <h3 class="reset-password-copy mt-3"> Reset Password</h3>
                        <form class="form-group" [formGroup]="Form" (ngSubmit)="submit()">
                                <p class="note-new-password">Note: New password cannot be the same as your old password.</p><br>
                                <label for="password" class="new-password-copy">New Password</label><br>
                                <input [type]="viewPass ? 'text' : 'password'" name="password" formControlName="password" (keyup)="newpasswordFun($event.target.value)" id="password" class="form-control">
                                <div *ngIf="submitted && f.password.errors" class="error-fields">
                                  <div *ngIf="f.password.errors.required">*New Password is required</div>
                                  <div *ngIf="f.password.errors.minlength">*Password should be atleast 8 characters</div>
                                </div>
                                <span toggle="#password-field" style="cursor: pointer;" (click)="viewPass = !viewPass" class="fa fa-fw fa-eye field-icon toggle-password"></span>
                                  <div style="display: flex;justify-content: space-between;">
                                  <div>
                                    <span class="password-strenght">Password Strength</span>
                                    <img class="" src="assets/images/password-strength.png" loading="lazy">
                                  </div>
                                  <div>
                                    <app-password-strength-bar [passwordToCheck]="newpassword" [barLabel]="barLabel">
                                    </app-password-strength-bar>
                                  </div>
                                </div>

                                <label for="remember-me" class="confirm-new-password-copy">
                                    Confirm New Password</label><br>
                                    <input [type]="viewConfPass ? 'text' : 'password'" name="password" formControlName="confirm" id="password" class="form-control">
                                    <div *ngIf="submitted && f.confirm.errors" class="error-fields">
                                      <div *ngIf="f.confirm.errors.required">*Confirm Password is required</div>
                                      <!-- <div *ngIf="f.password.errors.minlength">*Password should be atleast 8 characters</div> -->
                                      <div *ngIf="f.confirm.errors.confirmedValidator">Password does not match.</div>
                                    </div>
                                    <span toggle="#password-field" style="cursor: pointer;" (click)="viewConfPass = !viewConfPass" class="fa fa-fw fa-eye field-icon toggle-password"></span>
                                 <div class="text-center">
                                     <input type="submit" class="btnSubmit" value="Confirm"/>
                                       <!-- [ngClass]="{'disable-button':!setPassForm.valid}"
                                     [disabled]="!setPassForm.valid" /> -->
                                 </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
